import AuthContainer from "./AuthContainer";
import { useDispatch } from 'react-redux';
import A from './ActionCreators';




export default function LoginForm({mobile,setMode, loginContainerRef}){

  const dispatch = useDispatch();

  let gotoAppBypass;
  if( process.env.NODE_ENV !== 'production' ){
    if( typeof(navigator) !== typeof(undefined) ){
      if( !!navigator.webdriver ){
        gotoAppBypass = (

          <button 
            button="go-to-app"
            onClick={() => {

              dispatch(A.enterApp());
              setMode("ANNOTATION");

            }}
            class="fair-margin btn btn-warning" style={{
              fontSize:'1.5vw',
              marginTop:40,
              fontWeight:'bold',
                width:'80%'
            }}>Continue as guest</button>

        )
      }
    }

  }

  return(

    <div class="flex-expand" style={{
      }} ref={loginContainerRef}>
        <AuthContainer/>
        {gotoAppBypass}
      </div>

  )
}
